export const blockIconsCommonactionsHistoryNew = (
	<span className='material-symbols-outlined'>history</span>
);
